import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from "@mui/styles";
import InputAdornment from "@mui/material/InputAdornment";
import Icon from "@mui/material/Icon";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import HomeFooter from "components/Footer/HomeFooter.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
// import styles from '../styles/loginPage.js';
import loginBgDark from "assets/img/login_bg_dark.jpg";
import loginBgLight from "assets/img/login_bg_light.jpg";
import { useSelector, useDispatch } from "react-redux";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AlertDialog from '../components/AlertDialog';
import CountrySelect from '../components/CountrySelect';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import DialogActions from '@mui/material/DialogActions';
import { GoogleLogin } from '@react-oauth/google';
import { colors } from 'components/Theme/WebTheme.js';
import { ThemeContext } from "components/Theme/ThemeContext";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Typography, TextField, Grid } from "@mui/material";
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const useStyles = makeStyles(theme => ({
  container: {
    zIndex: "2",
    position: "relative",
    paddingTop: "90px", // Clears the header comfortably
    color: "#FFFFFF",
    paddingBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flex: 1
  },
  pageHeader: {
    minHeight: "100vh",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    margin: "0",
    padding: "0",
    border: "0",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      background: ({ isDark }) => isDark ? "rgba(0, 0, 0, 0.55)" : "rgba(255, 255, 255, 0.65)",
      pointerEvents: "none" // Allow clicks to pass through the overlay
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""',
      pointerEvents: "none" // Allow clicks to pass through
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    },
    "& footer": {
      position: "relative",
      width: "100%",
      zIndex: "10" // Higher z-index to stay above overlays
    }
  },
  form: {
    margin: "0"
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px"
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0"
  },
  inputIconsColor: {
    color: ({ isDark }) => isDark ? '#ffffff' : '#0F172A'
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  socialIconButton: {
    margin: "10px",
  },
  rtlDescription: {
    textAlign: 'right'
  },
  ltrDescription: {
    textAlign: 'left'
  },
  normalButton: {
    textTransform: "none",
    fontWeight: "600"
  },
  modernInput: {
    background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
    borderRadius: "12px",
    padding: "8px 14px",
    border: ({ isDark }) => isDark ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.08)",
    color: ({ isDark }) => isDark ? "#FFFFFF" : "#0F172A",
    marginTop: "4px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.05)",
    width: "100%",
    "&:hover": {
      borderColor: "rgba(233, 174, 49, 0.6)",
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(0, 0, 0, 0.03)"
    },
    "&.Mui-focused": {
      borderColor: "#E9AE31",
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.08)" : "rgba(255, 255, 255, 1)",
      boxShadow: ({ isDark }) => isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
    }
  },
  modernFormControl: {
    margin: "0 0 10px 0 !important",
    paddingTop: "20px !important",
  },
  modernLabel: {
    top: "4px !important",
    color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.5) !important" : "rgba(15, 23, 42, 0.5) !important",
    fontSize: "0.85rem !important",
    "&.MuiInputLabel-shrink": {
      transform: "translate(0, -6px) scale(0.75) !important",
      color: "#E9AE31 !important"
    }
  },
  primaryButton: {
    background: "linear-gradient(135deg, #FFD066 0%, #E9AE31 50%, #C28F1B 100%) !important",
    color: "#0A0A0B !important",
    borderRadius: "50px !important",
    boxShadow: "0 4px 15px rgba(233, 174, 49, 0.25) !important",
    fontWeight: "700 !important",
    padding: "8px 24px !important",
    width: "100%",
    textTransform: "none !important",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 6px 20px rgba(233, 174, 49, 0.4) !important",
      background: "linear-gradient(135deg, #FFE08C 0%, #F5C242 50%, #D69E2E 100%) !important"
    },
    "&:active": {
      transform: "translateY(0)"
    }
  },
  secondaryButton: {
    background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.05) !important" : "rgba(0, 0, 0, 0.03) !important",
    color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
    borderRadius: "50px !important",
    border: ({ isDark }) => isDark ? "1px solid rgba(255, 255, 255, 0.2) !important" : "1px solid rgba(0, 0, 0, 0.15) !important",
    fontWeight: "600 !important",
    padding: "8px 24px !important",
    width: "100%",
    textTransform: "none !important",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important",
    "&:hover": {
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.1) !important" : "rgba(0, 0, 0, 0.06) !important",
      borderColor: "#E9AE31 !important",
      color: "#E9AE31 !important"
    }
  },
  textField: {
    margin: "12px 0 20px 0 !important",
    "& label": {
      color: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.6) !important" : "rgba(15, 23, 42, 0.6) !important",
      fontSize: "0.9rem",
    },
    "& label.MuiInputLabel-shrink": {
      background: ({ isDark }) => isDark ? "#0d0d0f" : "#ffffff",
      padding: "0 8px !important",
      marginLeft: "-4px"
    },
    "& label.Mui-focused": {
      color: "#E9AE31 !important",
    },
    "& .MuiOutlinedInput-root": {
      background: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
      borderRadius: "12px",
      color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
      "& fieldset": {
        borderColor: ({ isDark }) => isDark ? "rgba(255, 255, 255, 0.15) !important" : "rgba(0, 0, 0, 0.15) !important",
        borderRadius: "12px",
        transition: "all 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: "rgba(233, 174, 49, 0.6) !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#E9AE31 !important",
        boxShadow: ({ isDark }) => isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
      },
      "& input": {
        padding: "14px 14px",
        color: ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
        caretColor: "#E9AE31 !important",
        "&:-webkit-autofill": {
          "-webkit-box-shadow": ({ isDark }) => isDark ? "0 0 0 100px #141416 inset !important" : "0 0 0 100px #F8FAFC inset !important",
          "-webkit-text-fill-color": ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
          "transition": "background-color 5000s ease-in-out 0s",
        },
        "&:-webkit-autofill:hover": {
          "-webkit-box-shadow": ({ isDark }) => isDark ? "0 0 0 100px #141416 inset !important" : "0 0 0 100px #F8FAFC inset !important",
          "-webkit-text-fill-color": ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
        },
        "&:-webkit-autofill:focus": {
          "-webkit-box-shadow": ({ isDark }) => isDark ? "0 0 0 100px #141416 inset !important" : "0 0 0 100px #F8FAFC inset !important",
          "-webkit-text-fill-color": ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
        },
        "&:-webkit-autofill:active": {
          "-webkit-box-shadow": ({ isDark }) => isDark ? "0 0 0 100px #141416 inset !important" : "0 0 0 100px #F8FAFC inset !important",
          "-webkit-text-fill-color": ({ isDark }) => isDark ? "#FFFFFF !important" : "#0F172A !important",
        }
      }
    },
  }
}));

export default function LoginPage(props) {
  const { authRef, RecaptchaVerifier, signInWithPhoneNumber } = useContext(FirebaseContext);
  const { t, i18n } = useTranslation();
  const {
    googleLogin,
    clearLoginError,
    mobileSignIn,
    countries,
    sendResetMail,
    verifyEmailPassword,
    requestMobileOtp,
    verifyMobileOtp,
    mainSignUp,
    checkUserExists,
    validateReferer
  } = api;
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const [capatchaReady, setCapatchaReady] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [verifier, setVerifier] = useState(null);
  const [mobileWithoutCountry, setMobileWithoutCountry] = useState('');
  const [showSignUp, setShowSignUp] = useState(false);
  const [message, setMessage] = useState(false)
  const [showPassword, setShowPassword] = useState(true)
  const [showConfirmPassword, setShowConfirmPassword] = useState(true);
  const isRTL = i18n.dir();

  const [data, setData] = React.useState({
    email: '',
    confirmpassword: "",
    country: "",
    contact: '',
    mobile: "",
    password: '',
    otp: '',
    verificationId: null,
    firstName: '',
    lastName: '',
    selectedcountry: null,
    usertype: 'customer',
    referralId: '',
    entryType: null
  });

  const [otpCalled, setOtpCalled] = useState();

  const { isDark } = useContext(ThemeContext);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

  const classes = useStyles({ isDark });
  const { ...rest } = props;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isAdminBypass = params.get('admin') === 'true';
    if (!isAdminBypass && !auth.profile) {
      navigate('/', { replace: true });
    }
  }, [auth.profile, navigate]);

  useEffect(() => {
    if (settings) {
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].label === settings.country) {
          setData({
            country: countries[i].phone,
            selectedcountry: countries[i],
          });
        }
      }
    }
  }, [settings, countries]);

  useEffect(() => {
    if (!window.recaptchaVerifier) {
      setCapatchaReady(true);
    }
    if (auth.profile) {
      if (auth.profile.uid) {
        let role = auth.profile.usertype;
        if (role === 'admin' || role === 'fleetadmin') {
          navigate('/dashboard');
        }
        else if (role === 'driver') {
          navigate('/driver-home');
        }
        else {
          navigate('/addbookings');
        }
      }
    }
    if (auth.error && auth.error.flag && auth.error.msg.message !== t('not_logged_in')) {
      if (auth.error.msg.message === t('require_approval')) {
        setCommonAlert({ open: true, msg: t('require_approval') })
      } else if (auth.error.msg.message === "Firebase: Error (auth/invalid-verification-code).") {
        setCommonAlert({ open: true, msg: t('login_error') })
      } else {
        if (data.contact && (data.contact === '' || !(!data.contact))) {
          setCommonAlert({ open: true, msg: t('login_error') })
        }
      }
    }
    if (auth.verificationId && otpCalled) {
      setOtpCalled(false);
      setData({ ...data, verificationId: auth.verificationId });
    }
  }, [auth.profile, auth.error, auth.verificationId, navigate, data, data.email, data.contact, capatchaReady, RecaptchaVerifier, t, setData, otpCalled, setOtpCalled]);


  const handleGoogleLogin = (credentialResponse) => {
    if (credentialResponse && credentialResponse.credential) {
      dispatch(googleLogin(credentialResponse.credential, null))
    } else {
      setCommonAlert({ open: true, msg: t('login_error') })
      setIsLoading(false);
    }
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' });
    if (auth.error.flag) {
      setData({ ...data, email: '', pass: '' });
      dispatch(clearLoginError());
    }
  };

  const onInputChange = (event) => {
    setData({ ...data, [event.target.id]: event.target.value })
  }

  const handleGetOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (data.country) {
      if (data.contact) {
        if (isNaN(data.contact)) {
          setData({ ...data, entryType: 'email' });
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (re.test(data.contact)) {
            await dispatch(verifyEmailPassword(
              data.contact,
              data.otp
            ));
          } else {
            setCommonAlert({ open: true, msg: t('proper_email') })
            setIsLoading(false);
          }
        } else {
          setData({ ...data, entryType: 'mobile' });
          let formattedNum = data.contact.replace(/ /g, '');
          const phoneNumber = "+" + data.country + formattedNum;
          if (formattedNum.length > 6) {
            if (settings.customMobileOTP) {
              dispatch(requestMobileOtp(phoneNumber));
              setData({ ...data, verificationId: true })
              setIsLoading(false)
            } else {
              if (!window.recaptchaVerifier || verifier === null) {
                window.recaptchaVerifier = await new RecaptchaVerifier(authRef(), 'sign-in-button', {
                  'size': 'invisible',
                  'callback': function (response) {
                    setCapatchaReady(true);
                  }
                });
              }
              const appVerifier = window.recaptchaVerifier;
              setVerifier(appVerifier);
              await signInWithPhoneNumber(authRef(), phoneNumber, appVerifier)
                .then(res => {
                  setData({ ...data, verificationId: res.verificationId })
                  setIsLoading(false)
                  window.recaptchaVerifier.clear();
                })
                .catch(error => {
                  setCommonAlert({ open: true, msg: error.code + ": " + error.message });
                  setIsLoading(false);
                });
            }
          } else {
            setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
            setIsLoading(false);
          }
        }
      } else {
        setCommonAlert({ open: true, msg: t('contact_input_error') })
        setIsLoading(false);
      }
    } else {
      setCommonAlert({ open: true, msg: t('country_blank_error') })
      setIsLoading(false);
    }
  }


  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (data.otp && data.otp.length === 6) {
      if (settings.customMobileOTP) {
        let formattedNum = data.contact.replace(/ /g, '');
        const phoneNumber = "+" + data.country + formattedNum;
        dispatch(verifyMobileOtp(
          phoneNumber,
          data.otp
        ));
      } else {
        await dispatch(mobileSignIn(
          data.verificationId,
          data.otp
        ));
      }
      setIsLoading(false);
    } else {
      setCommonAlert({ open: true, msg: t('otp_validate_error') })
      setIsLoading(false);
    }
  }

  const handleCancel = (e) => {
    setData({
      ...data,
      contact: null,
      verificationId: null
    });
    setIsLoading(false);
  }

  const onCountryChange = (object, value) => {
    if (value && value.phone) {
      setData({ ...data, country: value.phone, selectedcountry: value });
      setMobileWithoutCountry("")
    }
  };

  const forgotPassword = async (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(data.contact)) {
      await dispatch(sendResetMail(data.contact));
      setCommonAlert({ open: true, msg: t('email_send') });
    } else {
      setCommonAlert({ open: true, msg: t('proper_email') });
    }
  };

  const handleShowSignup = () => {
    setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: "customer", referralId: "" })
    setMobileWithoutCountry("")
    setShowSignUp(!showSignUp)
  }

  const mobileInputChange = (e) => {
    const val = e.target.value;
    setMobileWithoutCountry(val)
    let formattedNum = val.replace(/ /g, '');
    const phoneNumber = "+" + data.country + formattedNum;
    setData({ ...data, mobile: phoneNumber })
  }

  const handleChangeUser = (event) => {
    setData({ ...data, usertype: event.target.value });
  };
  const checkPasswordValidity = value => {
    if (value !== data.confirmpassword) {
      return (t('confirm_password_not_match_err'));
    }

    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(value)) {
      return (t('password_must_not_contain_whitespaces'));
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(value)) {
      return (t('password_must_have_at_least_one_uppercase_character'));
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(value)) {
      return (t('password_must_have_at_least_one_lowercase_character'));
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(value)) {
      return (t('password_must_contain_at_least_one_digit'));
    }

    const isValidLength = /^.{8,16}$/;
    if (!isValidLength.test(value)) {
      return (t('password_must_be_8-16_characters_long'));
    }

    return null;
  }

  const validateMobile = () => {
    let mobileValid = true;
    if (mobileWithoutCountry.length < 6) {
      mobileValid = false;
      setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
    }
    return mobileValid;
  }


  const handleSignUp = (e) => {
    e.preventDefault();
    new Promise((resolve, reject) => {
      setIsLoading(true)
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      const validatePassword = checkPasswordValidity(data.password);
      if (re.test(data.email)) {
        if (/\S/.test(data.firstName) && data.firstName.length > 0 && /\S/.test(data.lastName) && data.lastName.length > 0) {
          if (!validatePassword) {
            if (validateMobile()) {
              const userData = { ...data };
              if (userData.usertype === 'customer') delete userData.carType
              delete userData.confirmpassword;
              delete userData.pass;
              checkUserExists(userData).then((res) => {
                if (res.users && res.users.length > 0) {
                  setCommonAlert({ open: true, msg: t('user_exists') })
                  setIsLoading(false);
                } else {
                  if (userData.referralId && userData.referralId.length > 0) {
                    const processedReferralId = userData.referralId.toUpperCase().trim();
                    validateReferer(processedReferralId, userData.usertype).then((referralInfo) => {
                      if (referralInfo.uid) {
                        mainSignUp({ ...userData, referralId: processedReferralId, signupViaReferral: referralInfo.uid }).then((res) => {
                          if (res.uid) {
                            setCommonAlert({ open: true, msg: t('account_create_successfully') })
                            setShowSignUp(false);
                            setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: "customer", referralId: "" })
                            setMobileWithoutCountry("")
                            setIsLoading(false);
                            resolve();
                          } else {
                            setCommonAlert({ open: true, msg: t('reg_error') })
                            setIsLoading(false);
                          }
                        }).catch((error) => {
                          console.error("mainSignUp error:", error);
                          setCommonAlert({ open: true, msg: t('reg_error') })
                          setIsLoading(false);
                        })
                      } else if (referralInfo.error === 'role_mismatch') {
                        setCommonAlert({ open: true, msg: t('referral_role_mismatch', 'Referral code is not valid for your user type') })
                        setIsLoading(false);
                      } else {
                        setCommonAlert({ open: true, msg: t('referer_not_found') })
                        setIsLoading(false);
                      }
                    }).catch((error) => {
                      setCommonAlert({ open: true, msg: t('referer_not_found') })
                      setIsLoading(false);
                    });
                  } else {
                    mainSignUp(userData).then((res) => {
                      if (res.uid) {
                        setCommonAlert({ open: true, msg: t('account_create_successfully') })
                        setShowSignUp(false);
                        setData({ ...data, email: "", firstName: "", lastName: "", password: "", confirmpassword: "", usertype: "customer", referralId: "" })
                        setMobileWithoutCountry("")
                        setIsLoading(false);
                        resolve();
                      } else {
                        setCommonAlert({ open: true, msg: res.error || t('reg_error') })
                        setIsLoading(false);
                      }
                    }).catch((error) => {
                      console.error("mainSignUp error:", error);
                      setCommonAlert({ open: true, msg: t('reg_error') })
                      setIsLoading(false);
                    })
                  }
                }
              }).catch((error) => {
                console.error("checkUserExists error:", error);
                setCommonAlert({ open: true, msg: t('reg_error') })
                setIsLoading(false);
              })
            } else {
              setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
              reject();
            }
          } else {
            setCommonAlert({ open: true, msg: validatePassword })
            reject();
          }
        } else {
          setCommonAlert({ open: true, msg: t('proper_input_name') })
          reject();
        }
      } else {
        setCommonAlert({ open: true, msg: t('proper_email') })
        reject();
      }
    }).catch(() => { })
      .finally(() => { setIsLoading(false) })
  }

  return (
    <div>
      <Header
        color="transparent"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 80,
          color: isDark ? "dark" : "white"
        }}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: `url(${isDark ? loginBgDark : loginBgLight})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          transition: 'background-image 0.5s ease-in-out'
        }}
      >
        {showSignUp ?
          <div className={classes.container} style={{ width: '100%' }}>
            <Card style={{
              background: isDark ? "rgba(10, 10, 11, 0.85)" : "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(20px)",
              borderRadius: "20px",
              border: isDark ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(233, 174, 49, 0.2)",
              boxShadow: isDark ? "0 8px 32px 0 rgba(0, 0, 0, 0.37)" : "0 8px 32px 0 rgba(233, 174, 49, 0.08)",
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
              padding: "16px 20px"
            }}>
              <form className={classes.form}>
                <CardHeader
                  style={{
                    background: "transparent",
                    boxShadow: "none",
                    marginTop: "10px",
                    marginBottom: "10px"
                  }}
                  className={classes.cardHeader}
                >
                  <h4 style={{
                    color: isDark ? '#ffffff' : '#0F172A',
                    textShadow: isDark ? "0 0 10px rgba(233, 174, 49, 0.25)" : "none",
                    fontSize: 26,
                    fontWeight: "bold",
                    fontFamily: 'Outfit, sans-serif'
                  }}>{t("signup")}</h4>
                </CardHeader>
                <CardBody style={{ padding: "0 10px" }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("first_name")}
                        id="firstName"
                        variant="outlined"
                        fullWidth
                        required
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.firstName || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBoxIcon className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("last_name")}
                        id="lastName"
                        variant="outlined"
                        fullWidth
                        required
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.lastName || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBoxIcon className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {data.selectedcountry && settings.mobileLogin && countries && countries.length > 0 ? (
                        <CountrySelect
                          countries={countries}
                          label={t('select_country')}
                          value={data.selectedcountry}
                          onChange={onCountryChange}
                          style={{ marginTop: 12, marginBottom: 12 }}
                          disabled={data.verificationId ? true : false}
                          readOnly={!settings.AllowCountrySelection}
                          fieldStyle={{
                            '& .MuiOutlinedInput-root': {
                              color: isDark ? '#FFFFFF' : '#0F172A',
                              background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
                              borderRadius: '12px',
                              '& fieldset': {
                                borderColor: isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)',
                                borderRadius: '12px',
                              },
                              '&:hover fieldset': {
                                borderColor: 'rgba(233, 174, 49, 0.6)',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#E9AE31',
                              },
                            },
                            '& .MuiInputLabel-root': {
                              color: isDark ? 'rgba(255, 255, 255, 0.6)' : 'rgba(15, 23, 42, 0.6)',
                            },
                            '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                              background: isDark ? "#0d0d0f" : "#ffffff",
                              padding: "0 8px !important",
                              marginLeft: "-4px"
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                              color: '#E9AE31',
                            }
                          }}
                        />
                      ) : null}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("phone")}
                        id="mobileWithoutCountry"
                        variant="outlined"
                        fullWidth
                        required
                        className={classes.textField}
                        onChange={mobileInputChange}
                        value={mobileWithoutCountry || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <LocalPhoneIcon className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl variant="outlined" fullWidth className={classes.textField}>
                        <InputLabel id="user-type-label">
                          {t("User Type")}
                        </InputLabel>
                        <Select
                          labelId="user-type-label"
                          id="user-type-select"
                          value={data.usertype || ""}
                          label={t("User Type")}
                          onChange={handleChangeUser}
                          aria-label="userType"
                          sx={{
                            background: isDark ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.02)",
                            borderRadius: "12px",
                            color: isDark ? "#FFFFFF !important" : "#0F172A !important",
                            '& fieldset': {
                              borderColor: isDark ? "rgba(255, 255, 255, 0.15) !important" : "rgba(0, 0, 0, 0.15) !important",
                              borderRadius: "12px",
                              transition: "all 0.3s ease",
                            },
                            '&:hover fieldset': {
                              borderColor: "rgba(233, 174, 49, 0.6) !important",
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: "#E9AE31 !important",
                              boxShadow: isDark ? "0 0 0 3px rgba(233, 174, 49, 0.2)" : "0 0 0 3px rgba(233, 174, 49, 0.15)"
                            },
                            '& .MuiSelect-icon': {
                              color: isDark ? '#ffffff' : '#0F172A'
                            }
                          }}
                        >
                          <MenuItem value={"customer"}>{t("customer")}</MenuItem>
                          <MenuItem value={"driver"}>{t("driver")}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("email")}
                        id="email"
                        variant="outlined"
                        fullWidth
                        required
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.email || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <EmailIcon className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("password")}
                        id="password"
                        variant="outlined"
                        fullWidth
                        required
                        type={!showPassword ? "text" : "password"}
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.password || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {!showPassword ? (
                                <VisibilityIcon
                                  className={classes.inputIconsColor}
                                  onClick={() => setShowPassword(!showPassword)}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <VisibilityOffIcon
                                  className={classes.inputIconsColor}
                                  onClick={() => setShowPassword(!showPassword)}
                                  sx={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={t("confirm_password")}
                        id="confirmpassword"
                        variant="outlined"
                        fullWidth
                        required
                        type={!showConfirmPassword ? "text" : "password"}
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.confirmpassword || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {!showConfirmPassword ? (
                                <VisibilityIcon
                                  className={classes.inputIconsColor}
                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                  sx={{ cursor: 'pointer' }}
                                />
                              ) : (
                                <VisibilityOffIcon
                                  className={classes.inputIconsColor}
                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                  sx={{ cursor: 'pointer' }}
                                />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label={t("referralId")}
                        id="referralId"
                        variant="outlined"
                        fullWidth
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.referralId || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <AccountBoxIcon className={classes.inputIconsColor} />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
                <CardFooter className={classes.cardFooter}>
                  {message ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: 5, width: '100%' }}>
                      <Typography style={{ color: colors.GREEN, fontWeight: "bold", textAlign: 'center' }}>{t("account_create_successfully")}</Typography>
                      <Button className={classes.normalButton} simple color="info" onClick={() => { setShowSignUp(false) }}>
                        {t('signIn')}
                      </Button>
                    </div>
                  ) : isLoading ? (
                    <DialogActions
                      style={{
                        justifyContent: "center",
                        alignContent: "center",
                        width: '100%'
                      }}
                    >
                      <CircularProgress />
                    </DialogActions>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 10 }}>
                      <Button className={classes.primaryButton} type="submit" onClick={handleSignUp}>
                        {t('signup')}
                      </Button>
                      <Button className={classes.secondaryButton} onClick={handleShowSignup}>
                        {t('login')}
                      </Button>
                    </div>
                  )}
                </CardFooter>
              </form>
            </Card>
          </div>
          :
          <>
            <div id="sign-in-button" />
            <div className={classes.container} style={{ width: '100%' }}>
              <Card style={{
                background: isDark ? "rgba(10, 10, 11, 0.85)" : "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(20px)",
                borderRadius: "20px",
                border: isDark ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(233, 174, 49, 0.2)",
                boxShadow: isDark ? "0 8px 32px 0 rgba(0, 0, 0, 0.37)" : "0 8px 32px 0 rgba(233, 174, 49, 0.08)",
                width: "100%",
                maxWidth: "380px",
                padding: "16px 20px"
              }}>
                <form className={classes.form}>
                  {settings && settings.socialLogin ?
                    <CardHeader style={{
                      background: "transparent",
                      boxShadow: "none",
                      marginTop: "4px",
                      marginBottom: "4px",
                      paddingTop: "4px",
                      paddingBottom: "4px"
                    }} className={classes.cardHeader}>
                      <h4 style={{
                        color: isDark ? '#ffffff' : '#0F172A',
                        textShadow: isDark ? "0 0 10px rgba(233, 174, 49, 0.25)" : "none",
                        fontSize: 26,
                        fontWeight: "bold",
                        fontFamily: 'Outfit, sans-serif',
                        marginBottom: '6px'
                      }}>{t('login')}</h4>
                      <Typography variant="body2" sx={{
                        color: isDark ? 'rgba(255,255,255,0.6)' : '#475569',
                        textAlign: 'center',
                        mb: 0.5,
                        fontSize: '0.85rem',
                        fontWeight: 500
                      }}>
                        Welcome back! Please enter your details below.
                      </Typography>
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
                        <GoogleLogin
                          onSuccess={handleGoogleLogin}
                          onError={handleGoogleLogin}
                          theme={isDark ? "filled_black" : "outline"}
                          shape="pill"
                          width="300"
                        />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0 6px 0', color: isDark ? 'rgba(255,255,255,0.3)' : 'rgba(15,23,42,0.3)' }}>
                        <div style={{ flex: 1, height: '1px', backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(15,23,42,0.1)' }} />
                        <span style={{ padding: '0 12px', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{t('or', 'or')}</span>
                        <div style={{ flex: 1, height: '1px', backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(15,23,42,0.1)' }} />
                      </div>
                    </CardHeader>
                    : null}
                  <CardBody>

                    {data.selectedcountry && settings.mobileLogin && countries && countries.length > 0 ?
                      <CountrySelect
                        countries={countries}
                        label={t('select_country')}
                        value={data.selectedcountry}
                        onChange={onCountryChange}
                        style={{ marginTop: 12, marginBottom: 12 }}
                        disabled={data.verificationId ? true : false}
                        readOnly={!settings.AllowCountrySelection}
                        fieldStyle={{
                          '& .MuiOutlinedInput-root': {
                            color: isDark ? '#FFFFFF' : '#0F172A',
                            background: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.03)",
                            borderRadius: '10px',
                            '& fieldset': {
                              borderColor: isDark ? 'rgba(233, 174, 49, 0.4)' : 'rgba(233, 174, 49, 0.3)',
                              borderRadius: '10px',
                              boxShadow: isDark ? '0 0 5px rgba(233, 174, 49, 0.15)' : '0 2px 4px rgba(233, 174, 49, 0.05)'
                            },
                            '&:hover fieldset': {
                              borderColor: '#E9AE31',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#E9AE31',
                            },
                          },
                          '& .MuiInputLabel-root': {
                            color: isDark ? 'rgba(255, 255, 255, 0.7)' : '#475569',
                          },
                          '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                            background: isDark ? "#0d0d0f" : "#ffffff",
                            padding: "0 8px !important",
                            marginLeft: "-4px"
                          },
                          '& .MuiInputLabel-root.Mui-focused': {
                            color: isDark ? '#ffffff' : '#0F172A',
                          }
                        }}
                      />
                      : null}

                    <TextField
                      label={settings.emailLogin && settings.mobileLogin ? t('contact_placeholder') : settings.emailLogin && !settings.mobileLogin ? t('email_id') : t('mobile_number')}
                      id="contact"
                      variant="outlined"
                      fullWidth
                      required
                      className={classes.textField}
                      disabled={data.verificationId ? true : false}
                      onChange={onInputChange}
                      value={data.contact || ""}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <AccountBoxIcon className={classes.inputIconsColor} />
                          </InputAdornment>
                        ),
                      }}
                    />
                    {(data.contact && isNaN(data.contact)) || (settings.emailLogin && !settings.mobileLogin) ?
                      <TextField
                        label={((data.contact && isNaN(data.contact)) || (settings.emailLogin && !settings.mobileLogin)) ? t('password') : t('otp_here')}
                        id="otp"
                        variant="outlined"
                        fullWidth
                        type="password"
                        required
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.otp || ""}
                        autoComplete="off"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Icon className={classes.inputIconsColor}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                        }}
                      />
                      : null}

                    {data.verificationId ?
                      <TextField
                        label={t('otp')}
                        id="otp"
                        variant="outlined"
                        fullWidth
                        type="password"
                        required
                        className={classes.textField}
                        onChange={onInputChange}
                        value={data.otp || ""}
                        autoComplete="off"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Icon className={classes.inputIconsColor}>
                                lock_outline
                              </Icon>
                            </InputAdornment>
                          ),
                        }}
                      />
                      : null}

                  </CardBody>
                  <CardFooter className={classes.cardFooter}>
                    {isLoading ?
                      <DialogActions style={{ justifyContent: 'center', alignContent: 'center' }}>
                        <CircularProgress />
                      </DialogActions>
                      :
                      !data.verificationId ?
                        <div>
                          <Button className={classes.primaryButton} onClick={handleGetOTP}>
                            {data.contact && isNaN(data.contact) ? t('login') : t('login_otp')}
                          </Button>
                          <Button className={classes.secondaryButton} style={{ marginTop: '10px' }} onClick={handleShowSignup}>
                            {t('signup')}
                          </Button>
                          {data.contact && isNaN(data.contact) ?
                            <Button className={classes.normalButton} simple color="primary" size="lg" onClick={() => forgotPassword()} style={{ color: isDark ? "#9CA3AF" : "#475569", fontSize: "0.8rem", width: "100%", marginTop: "10px" }}>
                              {t('forgot_password')}
                            </Button>
                            : null}
                        </div>
                        :
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%' }}>
                          <Button className={classes.primaryButton} type="submit" onClick={handleVerifyOTP}>
                            {t('verify_otp')}
                          </Button>
                          <Button className={classes.secondaryButton} onClick={handleCancel}>
                            {t('cancel')}
                          </Button>
                        </div>
                    }
                  </CardFooter>
                </form>
                {/* Duplicate Signup Removed */}

                {
                  !settings.AllowCriticalEditsAdmin ?
                    <Card style={{
                      borderRadius: 50, shadowOffset: { width: 0, height: 0 },
                      shadowOpacity: 0.5,
                      shadowRadius: 10, bottom: 25
                    }}>
                      <div style={{ alignSelf: 'center' }}>
                        <p className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ color: 'black', fontSize: 18, }} >{t('country_1')} : Qatar</p>
                        <p className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ color: 'black', fontSize: 18, }}>{t('mobile')} : 98887777</p>
                        <p className={isRTL === "rtl" ? classes.rtlDescription : classes.ltrDescription} style={{ color: 'black', fontSize: 18, }}>{t('otp')} : 123456</p>
                      </div>
                    </Card>
                    : null
                }
              </Card>
            </div>
          </>
        }
      </div >
      <HomeFooter />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div >
  );
}